import RuleTargetsTable from './RuleTargetsTable';
export default RuleTargetsTable;
